"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var clsx_1 = __importDefault(require("clsx"));
var style = __importStar(require("./NativeSelect.style"));
var SelectIcon = function () {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.icon, focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "ArrowDropDownIcon" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7 10l5 5 5-5z" }) })));
};
var NativeSelectInput = (0, react_1.forwardRef)(function (props, ref) {
    var className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _a = props.variant, variant = _a === void 0 ? 'standard' : _a, 
    // @ts-ignore
    options = props.options, multiple = props.multiple, rest = __rest(props, ["className", "disabled", "IconComponent", "inputRef", "variant", "options", "multiple"]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("select", __assign({ className: (0, clsx_1.default)(className), css: style.root, disabled: disabled, ref: inputRef || ref }, rest, { children: options &&
                    options.map(function (option, index) {
                        if ((option === null || option === void 0 ? void 0 : option.value) === undefined) {
                            return;
                        }
                        else {
                            return ((0, jsx_runtime_1.jsx)("option", __assign({ value: option === null || option === void 0 ? void 0 : option.value }, { children: (option === null || option === void 0 ? void 0 : option.label) ? option === null || option === void 0 ? void 0 : option.label : option === null || option === void 0 ? void 0 : option.value }), index));
                        }
                    }) })), multiple ? null : (0, jsx_runtime_1.jsx)(SelectIcon, {})] }));
});
exports.default = NativeSelectInput;
//# sourceMappingURL=NativeSelectInput.js.map